var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        visible: _vm.visible,
        title: _vm.title,
        "ok-title": _vm.okTitle,
        "cancel-title": _vm.cancelTitle,
        "ok-variant": "danger",
        "cancel-variant": "outline-secondary",
        "ok-only": "",
      },
      on: {
        ok: _vm.handleOk,
        cancel: _vm.handleCancel,
        hidden: _vm.handleCancel,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function (ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "danger" },
                  on: {
                    click: function ($event) {
                      return ok()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.okTitle) + " ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.cancelTitle) + " ")]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("p", { staticClass: "mb-3" }, [_vm._v(_vm._s(_vm.message))]),
      _c(
        "b-form-group",
        {
          attrs: {
            label: _vm.justificationLabel,
            "label-for": _vm.modalId + "-justification",
          },
        },
        [
          _c("b-form-textarea", {
            attrs: {
              id: _vm.modalId + "-justification",
              rows: "4",
              placeholder: _vm.justificationPlaceholder,
              state: _vm.validationState,
            },
            model: {
              value: _vm.localJustification,
              callback: function ($$v) {
                _vm.localJustification = $$v
              },
              expression: "localJustification",
            },
          }),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.validationState } },
            [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }